import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 py-10 text-center">
      <h1 className="font-display text-3xl font-bold">404</h1>
      <p className="text-sm text-muted-foreground">That page does not exist.</p>
      <div className="mt-2 flex gap-2">
        <Button asChild size="sm" variant="outline">
          <Link href="/">Go home</Link>
        </Button>
        <Button size="sm" variant="ghost" onClick={() => window.history.back()}>
          Back
        </Button>
      </div>
    </div>
  );
}
